import { render, staticRenderFns } from "./FornecedorView.vue?vue&type=template&id=48c3ee72&"
import script from "./FornecedorView.vue?vue&type=script&lang=js&"
export * from "./FornecedorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports